import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import contentdata from '../assets/contentdata.json'
import ProgramCard from '../components/ProgramCard'

const YanchaKids = () => {
    const [foundation, setFoundation] = useState([])
    const [transformation, setTransformation] = useState([])
    const [others, setOthers] = useState([])


    const data = contentdata;

    useEffect(() => {
        setFoundation(data.kids_foundation)
        setTransformation(data.kids_transformation)
        setOthers(data.kids_others)
        // setFeaturevideos(data.featurevideos)
        // setParentsspeak(data.parentsspeak)
    }, [])
    return (
        <div>
            {/* page heading */}
            <div className='spacer'>
                <p className='large-gradient-heading brand-text'>Yancha Kids</p>
                <p className='gradient-heading brand-text'>Foundation Program</p>
            </div>

            {/* flashcards */}
            <div className='spacer flex flex-row flex-wrap -m-2'>
                {
                    foundation.map(card => (
                        <div className='w-1/2'>
                            <Link to="/yancha-kids-initiation">
                                <ProgramCard cardinfo={card} />
                            </Link>
                        </div>
                    ))
                }
            </div>

            {/* page heading */}
            <div className='spacer'>
                <p className='gradient-heading brand-text'>Transformation Program</p>
            </div>

            {/* flashcards */}
            <div className='spacer flex flex-row flex-wrap -m-2'>
                {
                    transformation.map(card => (
                        <div className='w-1/2'>
                            <Link to="/yancha-kids-initiation">
                                <ProgramCard cardinfo={card} />
                            </Link>
                        </div>
                    ))
                }
            </div>

            {/* page heading */}
            <div className='spacer'>
                <p className='gradient-heading brand-text'>Other Offerings</p>
            </div>

            {/* flashcards */}
            <div className='spacer flex flex-row flex-wrap -m-2'>
                {
                    others.map(card => (
                        <div className='w-1/2'>
                            <Link to="/yancha-kids-initiation">
                                <ProgramCard cardinfo={card} />
                            </Link>
                        </div>
                    ))
                }
            </div>

        </div>
    )
}

export default YanchaKids